/* Provenance badge labels — the SINGLE source of truth for how a masjid's origin is
   shown in the UI. Rows carry `import_source` values like 'osm-overpass',
   'OpenStreetMap:Nominatim:node/123', null (self-registered), or (future) 'google_places'.
   The badge must reflect the REAL source — never hardcode "OSM".

   Precedence note: this is ONLY consulted for unverified/unclaimed rows. A verified or
   claimed masjid always shows its verified/committee label (unchanged) — the caller
   decides that BEFORE falling back to this helper. */

export interface SourceBadge {
  /** long form, e.g. "OSM record" / "Google listing" / "Community listing" */
  label: string
  /** short/mono form for compact pills, e.g. "OSM" / "GOOGLE" / "LISTED" */
  short: string
}

export function sourceBadgeLabel(importSource: string | null | undefined): SourceBadge {
  const s = (importSource ?? '').trim().toLowerCase()

  // OpenStreetMap imports: 'osm-overpass', 'OpenStreetMap:Nominatim:...', etc.
  if (s.startsWith('osm') || s.includes('openstreetmap')) {
    return { label: 'OSM record', short: 'OSM' }
  }

  // Google Places discovery (future insertion path).
  if (s === 'google_places') {
    return { label: 'Google listing', short: 'GOOGLE' }
  }

  // null / unknown / self-registered / anything else → honest neutral fallback.
  // (Fixes the latent bug where null-import_source self-registrations mislabelled as OSM.)
  return { label: 'Community listing', short: 'LISTED' }
}
